import SolutionPartnerService from '@/services/SolutionPartnerService';
import SupplierService from '@/services/SupplierService';

export default {
  getHost () {
    return process.env.VUE_APP_SOLUTION_PARTNERS;
  },
  getToken () {
    return SolutionPartnerService.singleSignOn();
  },
  redirectUrlGenerator ({ token, redirectUrl }) {
    return `${this.getHost()}?redirect=${redirectUrl}&token=${token}`;
  },
  getGtmEvent () {
    return {
      event: 'GAEvent',
      eventCategory: 'AccountSSOPage',
      action: 'Solution Partner SSO',
      eventLabel: SupplierService.getSupplierId(),
    };
  },
};
